export const TIPO_DOC = {
  CI: 1,
  RUT: 2,
  ASSURED: 0
};

export const COD_COIN = ['UYU', 'USD'];
export const COD_COIN_VALUE = {
  UYU: 0,
  USD: 1
};

// Limite de seguridad al validar el usuario contra la libreria de Google recaptcha V3
export const SECURITY_LIMIT = 0.5;